<script>
import ModelShow from '../models/show';

export default {
  extends: ModelShow,
  page: {
    title: "Detail JALA Cycles",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('jala_cycles.singular')) }},
    resourceRoute: {default: 'jala_cycles'},
    modelVariable: {default: 'jala_cycle'},
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('jala_cycles.plural')),
    }
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.upperFirst(this.$t('jala_cycles.plural')),
          href: "/jala_cycles",
        },
        {
          text: this.model && this.model.id ? this.$moment(this.model['started_at']).format('DD MMMM YYYY') : this.$route.params.key,
          href: `/jala_cycles/${this.$route.params.key}`,
          active: true,
        }
      ]
    },
    modelMapped() {
      return this.lodash.isEmpty(this.model) ? [] : [{
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.pond`)),
        item: this.model.pond,
        value: {
          props: { item: { type: Object, default() { return {} } } },
          template: '<router-link :to="`/jala_ponds/${item.id}`">{{ `${lodash.get(item, "farm.name")} - ${lodash.get(item, "name")}` }}</router-link>'
        }
      }, {
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.started_at`)),
        value: this.$moment(this.model.started_at).format('DD MMMM YYYY'),
      }, {
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.age`)),
        value: this.$numeral(this.model.age).format('0,0.[00]'),
      }, {
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.total_seed`)),
        value: this.$numeral(this.model.total_seed).format('0,0.[00]'),
      }, {
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.total_seed_type`)),
        value: this.lodash.upperFirst(this.$t(`jala_cycles.${this.model.total_seed_type}`)),
      }, {
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.hatchery`)),
        value: this.model.hatchery.name,
      }]
    }
  },
  methods: {
    delete() {
      return this.$axios.delete(`/jala/cycles/${this.$route.params.key}`)
    },
    fetchModel() {
      this.loading = true;
      return this.$axios.get(`/jala/cycles/${this.$route.params.key}`, {
        params: { with: 'pond.farm,hatchery' }
      }).then((response) => {
        const { data: { data } } = response;
        this.model = data;
        return response;
      }).catch((error) => this.failedAlert(error))
      .finally(() => this.loading = false)
    }
  }
}
</script>
